import * as ReactDOM from 'react-dom';

export default function removeInteractiveElementsForReadingPane(element: HTMLElement) {
    ReactDOM.unmountComponentAtNode(element);
}
